import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardList, Megaphone, CheckCircle } from 'lucide-react';
export function OrganizerBenefits() {
  const benefits = [{
    icon: ClipboardList,
    title: 'Simple planning',
    description: "Get 2-3 curated itinerary options based on your group's interests, budget, and travel dates. We guide you through departure cities, inclusions, and timeline."
  }, {
    icon: Megaphone,
    title: 'Promotion support',
    description: 'Receive shareable flyers, trip summaries, and promotional materials to help you recruit travelers from your community without the design headache.'
  }, {
    icon: CheckCircle,
    title: 'On-trip confidence',
    description: 'Travel with professional tour management, clear inclusions, and 24/7 support. We handle logistics, hotels, and transport so you can enjoy the journey.'
  }];
  return <section className="py-20 bg-white" data-id="element-201">
      <div className="container mx-auto px-4" data-id="element-202">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-203">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-primary mb-4" data-id="element-204">
            Made for group organizers
          </h2>
          <p className="text-lg text-gray-600" data-id="element-205">
            We know organizing a trip is a big responsibility. Our process is
            designed to make you look like a hero while we do the heavy lifting.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-206">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-neutral-50 rounded-xl p-8 border border-gray-100 hover:shadow-lg transition-shadow duration-300" data-id="element-207">
              <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center shadow-sm mb-6 text-teal border border-teal/20" data-id="element-208">
                <benefit.icon size={28} data-id="element-209" />
              </div>
              <h3 className="text-xl font-bold text-primary mb-3" data-id="element-210">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-211">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}